'use client';

import { faDesktop, faFlaskVial, faSignalStream, faStethoscope } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterPill } from './filter-pill.component';

import { MostSearchedResultType, SearchType } from '@/types/most-search-type';
import { MostSearchedType } from '@/app/(main)/(pages)/_types/most-searched.type';

interface ProceduresFilterProps {
  onFilterSelect: (filter: MostSearchedType) => void;
  selectedFilter: MostSearchedType;
  procedures?: MostSearchedResultType[];
}

export function ProceduresFilter({ onFilterSelect, selectedFilter, procedures }: ProceduresFilterProps) {
  const hasPresentialConsultation = procedures?.some(
    (item) => item.type === SearchType.PRESENTIAL_CONSULTATION && item.procedures.length > 0,
  );
  const hasOnlineConsultation = procedures?.some(
    (item) => item.type === SearchType.ONLINE_CONSULTATION && item.procedures.length > 0,
  );
  const hasImageExam = procedures?.some((item) => item.type === SearchType.IMAGE_EXAM && item.procedures.length > 0);
  const hasLaboratoryExam = procedures?.some(
    (item) => item.type === SearchType.LABORATORIAL_EXAM && item.procedures.length > 0,
  );

  if (Number(procedures?.length) <= 1) {
    return null;
  }

  return (
    <div data-testid={DataTestIdEnum.CITY_MOST_SEARCHED_SECTION_FILTER}>
      <div className="mb-4 w-full">
        <div className="flex overflow-x-auto gap-2 no-scrollbar w-full px-6 sm:px-16 md:px-0 md:mx-auto md:max-w-2xl md:pl-9 xl:p-0 xl:max-w-5xl 3xl:max-w-7xl md:justify-start">
          {hasPresentialConsultation && (
            <FilterPill
              id={SearchType.PRESENTIAL_CONSULTATION}
              dataTestId={DataTestIdEnum.CITY_FILTER_PRESENTIAL_CONSULTATION}
              label="Consultas"
              icon={faStethoscope}
              action={() => {
                onFilterSelect(SearchType.PRESENTIAL_CONSULTATION);
              }}
              variant={selectedFilter === SearchType.PRESENTIAL_CONSULTATION ? 'success' : 'light'}
              className="cursor-pointer ml-0"
            />
          )}
          {hasOnlineConsultation && (
            <FilterPill
              id={SearchType.ONLINE_CONSULTATION}
              dataTestId={DataTestIdEnum.CITY_FILTER_ONLINE_CONSULTATION}
              label="Teleconsulta"
              icon={faDesktop}
              action={() => {
                onFilterSelect(SearchType.ONLINE_CONSULTATION);
              }}
              variant={selectedFilter === SearchType.ONLINE_CONSULTATION ? 'success' : 'light'}
              className="cursor-pointer"
            />
          )}
          {hasImageExam && (
            <FilterPill
              id={SearchType.IMAGE_EXAM}
              dataTestId={DataTestIdEnum.CITY_FILTER_IMAGE_EXAM}
              label="Exames de imagem"
              icon={faSignalStream}
              action={() => {
                onFilterSelect(SearchType.IMAGE_EXAM);
              }}
              variant={selectedFilter === SearchType.IMAGE_EXAM ? 'success' : 'light'}
              className="cursor-pointer"
            />
          )}
          {hasLaboratoryExam && (
            <FilterPill
              id={SearchType.LABORATORIAL_EXAM}
              dataTestId={DataTestIdEnum.CITY_FILTER_LABORATORIAL_EXAM}
              label="Exames laboratoriais"
              icon={faFlaskVial}
              action={() => {
                onFilterSelect(SearchType.LABORATORIAL_EXAM);
              }}
              variant={selectedFilter === SearchType.LABORATORIAL_EXAM ? 'success' : 'light'}
              className="cursor-pointer"
            />
          )}
        </div>
      </div>
    </div>
  );
}
